import { createFileRoute, redirect } from "@tanstack/react-router";

// Moved to consignment-request.
export const Route = createFileRoute("/admin/consignment/requests/")({
	beforeLoad() {
		throw redirect({ to: "/admin/consignment-request", replace: true });
	},
});
